import { render, staticRenderFns } from "./PackageDetails.vue?vue&type=template&id=233dabf6"
import script from "./PackageDetails.vue?vue&type=script&lang=js"
export * from "./PackageDetails.vue?vue&type=script&lang=js"
import style0 from "./PackageDetails.vue?vue&type=style&index=0&id=233dabf6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports